var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreenCloud(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 518.51 208.3",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #1c3135;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "newer"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M424.5,58.4c-23.2-8.81-46.41-17.62-69.61-26.44-19.95-7.58-41.09-15.29-62.14-11.76-21.05,3.52-41.05,22.83-37.2,43.82,6.94-9.48,1.23-23.87-8.65-30.23-9.88-6.36-22.28-6.88-34.03-7.21-25.1-.7-50.21-1.4-75.31-2.1-19.27-.54-40.5-.43-55.16,12.1-14.66,12.52-13.89,42.11,4.88,46.51-.52-4.44-5.88-6.25-10.28-7.07-24.01-4.51-53.12-7.31-68.7,11.5-10.97,13.24-10.37,33.4-2.29,48.57,8.08,15.18,22.3,26.14,37.09,34.91,31.5,18.68,67.61,29.51,104.19,31.26,11.31.54,23.26.06,32.93-5.84,9.66-5.9,15.86-18.82,10.81-28.95,8.21,25.58,38.94,35.49,65.65,38.33,22.41,2.39,44.99,2.44,67.53,2.5,12.29.03,25.08-.05,36.15-5.4,11.07-5.35,19.82-17.65,16.93-29.6,19.72,7.59,40.93,11.28,62.05,10.78,8.19-.19,16.67-1.11,23.7-5.31,18.15-10.85,18.21-36.66,16.04-57.7,7.86,10.12,25.44,5.89,32.64-4.72,7.2-10.61,7.05-24.39,6.64-37.2-.44-13.65-.88-27.3-1.32-40.95-.21-6.38-.47-13-3.37-18.69-6.49-12.72-22.93-15.84-37.12-17.48-18.57-2.14-38.04-4.18-55.4,2.76-17.36,6.94-31.38,26.06-25.93,43.94"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenCloud);
export default __webpack_public_path__ + "static/media/green-cloud.c9f0e39864e188e0f36054ccfa4f72dd.svg";
export { ForwardRef as ReactComponent };